import { ReactNode } from 'react';

import { AuthContextProvider } from './AuthContextProvider';
import { MainContextProvider } from './MainContextProvider';
import { UserStateProvider } from './UserStateProvider';
import { RootContext, WidgetEventsManager } from './WidgetEventsManager';
import { MatchContextRegistryProvider } from './layout/matching/MatchContextRegistry';
import { Configurations } from './model/api';

export interface AppContextProps {
  rootElement: HTMLElement;
  appConfig: Configurations;
  children?: ReactNode | ReactNode[];
}

export const AppContext = ({ children, appConfig, rootElement }: AppContextProps) => {
  return (
    <UserStateProvider>
      <RootContext.Provider value={rootElement}>
        <WidgetEventsManager appConfig={appConfig}>
          <MatchContextRegistryProvider>
            <AuthContextProvider>
              <MainContextProvider>{children}</MainContextProvider>
            </AuthContextProvider>
          </MatchContextRegistryProvider>
        </WidgetEventsManager>
      </RootContext.Provider>
    </UserStateProvider>
  );
};
